import Vue from 'vue';

Vue.directive('dialogDrag', {
  inserted(el: HTMLElement) {
    // 用 Vue.nextTick 保证子节点渲染完成后再查找
    Vue.nextTick(() => {
      const dragHeader = el.querySelector('.drag-header') as HTMLElement;
      const dragBox = el.querySelector('.drag-box') as HTMLElement;

      if (!dragHeader || !dragBox) {
        console.warn('dialogDrag指令：未找到必要的.drag-header或.drag-box元素');
        return;
      }

      // 设置拖拽
      setupDrag(dragHeader, dragBox);
    });
  }
});

function setupDrag(dragHeader: HTMLElement, dragBox: HTMLElement) {
  // 设置拖动头部鼠标样式
  dragHeader.style.cursor = 'move';

  dragHeader.onmousedown = (e: MouseEvent) => {
    // 获取drag-box的初始位置
    const boxRect = dragBox.getBoundingClientRect();

    // 计算鼠标相对于drag-box左上角的偏移量
    const offsetX = e.clientX - boxRect.left;
    const offsetY = e.clientY - boxRect.top;

    document.onmousemove = (moveEvent) => {
      dragBox.style.transform = 'none'

      // 计算新位置，保持鼠标相对于drag-box左上角的偏移量
      const newLeft = moveEvent.clientX - offsetX;
      const newTop = moveEvent.clientY - offsetY;

      // 设置新位置
      dragBox.style.left = `${newLeft}px`;
      dragBox.style.top = `${newTop}px`;
    };

    document.onmouseup = () => {
      // 清除事件监听
      document.onmousemove = null;
      document.onmouseup = null;
    };
  };
}